import { DatumId } from '../core/Chart.types';

type ChartItemDataAttributes = {
  id: DatumId;
  index: number;
  highlighted: boolean;
  selected: boolean;
  interactive: boolean;
};

export const itemAttrs = ({ id, index, highlighted, selected, interactive }: ChartItemDataAttributes) => ({
  'data-datum-id': id,
  'data-index': index,
  'data-highlighted': highlighted || undefined,
  'data-selected': selected || undefined,
  'data-interactive': interactive || undefined,
});
